<template>
    <div
            v-bind:class="{root: jobType.isRoot()}"
            class="job-type-node">
        <div
                v-if="!jobType.isLeaf()"
                v-on:click="toggleExpansion"
                class="caret-container">
            <i
                    v-bind:class="[expanded ? 'fa-caret-down' : 'fa-caret-right']"
                    class="fa" aria-hidden="true"></i>
        </div>
        <div
                v-else
                class="caret-container">
        </div>
        <label class="job-type-name label-btn-style" v-bind:for="_uid" v-if="!isParentJobTypeOther()">
            <input
                v-on:click="onCheckboxClick"
                v-model="jobType.selected"
                type="checkbox"
                v-bind:id="_uid"
                v-bind:data-id="jobType.id"
            >
            <span>{{ jobType.name }}</span>
        </label>

        <!-- TODO Create a  configuration file from BXL VL WAL or from database -->
        <ul v-if="jobType.isSpecificSkill && this.user.country ==='BE' "  class="list-inline specific-skill" >
            <li class="list-inline-item" v-for="region in ['BXL','VL','WAL']">
                <input v-bind:id="jobType.id+region" type="checkbox" v-model="jobType.regionsSkillsSelected" :value="region"/>
                <label  v-bind:for="jobType.id+region">{{ region }}</label>
            </li>
        </ul>

        <template v-if=" revealMaxPartnerPriceOptions() ">

            <div class="display-inline" >
                <span class="btn-control-partner-price btn-control-partner-price-left" @click="decreasePartnerPrice"> <i class="fa fa-minus"></i> </span>
                <span class="max-partner-price low-cost ">
                    {{ normalCost }}{{ $currency.symbol(user.country)}}
                </span>
                <span class="btn-control-partner-price btn-control-partner-price-right" @click="increasePartnerPrice"> <i class="fa fa-plus"></i> </span>
            </div>

            <div class="clearfix"></div>
        </template>
        <div v-show="expanded" class="children">
            <SkillsJobTypeNode
                    v-for="jobType in orderedChildren"
                    v-bind:key="jobType.id"
                    v-bind:jobType="jobType"
                    v-bind:user="user"
                    v-on:selected="onChildSelected"
                    v-on:unselected="onChildUnselected">
            </SkillsJobTypeNode>
        </div>
    </div>
</template>

<script>

    import CurrencyInput from '../CurrencyInput';
    import {JobType} from '../../../../../vue-widgets/src/JobType/JobType';

    export default {
        name: 'SkillsJobTypeNode', // needed for a recursive component
        props: {
            jobType: JobType,
            user: Object,
        },
        data() {
            return {
                expanded: this.jobType.selected,
                intervalMaxPartnerPrice: 5,
                defaultMaxPartnerPrice: this.jobType.normalCostBasePrice * 0.5,
				minMaxPartnerPrice: 25 / this.user.pricePolicies.maxHopeMultiplier
            }
        },
        methods: {
            revealMaxPartnerPriceOptions(){
                return (
                    this.jobType.selected &&
                    this.user.isPureContact === true &&
                    this.jobType.maxPartnerPrice !== undefined &&
                    this.jobType.isLeaf() &&
                    !this.isParentJobTypeOther()
                )
            },
            isParentJobTypeOther(){
                return this.jobType.id === 9 // Hardcoded ID job_type.id JobTypeName Autre
            },
            toggleExpansion() {
                this.expanded = !this.expanded;
            },
            onChildSelected() {
                if (this.jobType.selected === false) {
                    this.jobType.selected = true;
                    // select 'other' child, if exists
                    /*for (const childJobType of this.jobType.children) {
                        if (childJobType.isOther === true) {
                            childJobType.selected = true;
                        }
                    }*/
                    this.$emit('selected');
                }
            },
            onChildUnselected() {
                const noChildsExceptOtherAreSelected = this.jobType.children.every(jobType => jobType.selected === false || jobType.isOther === true);
                if (noChildsExceptOtherAreSelected) {
                    // unselected 'other' child, if exists
                    /*for (const childJobType of this.jobType.children) {
                        if (childJobType.isOther === true) {
                            childJobType.selected = false;
                        }
                    }*/
                    // unselect 'this' and ancestors if no childs are selected
                    this.jobType.selected = false;
                    this.$emit('unselected');
                }
            },
            onCheckboxClick() {
                this.$nextTick(() => { // on next tick to be sure that 'this.jobType.selected' is already updated via v-model
                    // Changed by Adrian because the selection takes places just after click
                    if (this.jobType.selected === false) {
                        // select all ancestors
                        this.$emit('selected');

                        // Add Default MaxPartnerPrice
                        this.addDefaultMaxPartnerPriceIfnotIntitiallySelected();

                        // select all descendants
                        for (const childComponent of this.$children) {
                            childComponent.doSelectByParent();
                        }
                    }
                    else {
                        // unselect ancestors if needed
                        this.$emit('unselected');

                        // Remove Default MaxPartnerPrice
                        this.removeDefaultMaxPartnerPriceIfnotIntitiallySelected();

                        // unselect all descendants
                        for (const childComponent of this.$children) {
                            childComponent.unSelectByParent();
                        }
                    }
                });
            },
            doSelectByParent() {
                this.jobType.selected = true;
                // select all descendants
                for (const childComponent of this.$children) {
                    childComponent.doSelectByParent();
                }
            },
            unSelectByParent() {
                this.jobType.selected = false;
                // unselect all descendants
                for (const childComponent of this.$children) {
                    childComponent.unSelectByParent();
                }
            },
            increasePartnerPrice(){
              if(this.jobType.normalCostBasePrice == 0) {
                if(this.jobType.maxPartnerPrice < 0){
                  this.jobType.maxPartnerPrice++;
                  let multiple = this.intervalMaxPartnerPrice;
                  this.jobType.maxPartnerPrice = Math.ceil((this.jobType.maxPartnerPrice)/multiple)*multiple;
                  // Correction
                  if(this.jobType.maxPartnerPrice>0){
                    this.jobType.maxPartnerPrice = 0;
                  }
                }
              }else{
                this.jobType.maxPartnerPrice++;
                let multiple = this.intervalMaxPartnerPrice;
                this.jobType.maxPartnerPrice = Math.ceil((this.jobType.maxPartnerPrice)/multiple)*multiple;
              }
            },
            decreasePartnerPrice(){
              let multiple = this.intervalMaxPartnerPrice;
                this.jobType.maxPartnerPrice--;
                this.jobType.maxPartnerPrice = Math.floor((this.jobType.maxPartnerPrice)/multiple)*multiple;
            },
            addDefaultMaxPartnerPriceIfnotIntitiallySelected(){
                if(this.jobType.intitiallySelected === false){
                    if(this.jobType.normalCostBasePrice == 0) {
                      this.jobType.maxPartnerPrice = -30; // demandé par gilles sur whatsapp le 29 juillet
                    }else{
                      this.jobType.maxPartnerPrice = this.defaultMaxPartnerPrice;
                    }
                }
                // Add Default MaxPartnerPrice to Childrens
                for (const childComponent of this.$children) {
                    childComponent.addDefaultMaxPartnerPriceIfnotIntitiallySelected();
                }
            },
            removeDefaultMaxPartnerPriceIfnotIntitiallySelected(){
                if(this.jobType.intitiallySelected === false){
                    this.jobType.maxPartnerPrice = undefined;
                }
                // Remove Default MaxPartnerPrice to Childrens
                for (const childComponent of this.$children) {
                    childComponent.removeDefaultMaxPartnerPriceIfnotIntitiallySelected();
                }

            },
        },
        computed: {
            normalCost(){
                return Math.round(this.jobType.maxPartnerPrice);
            },
            orderedChildren() {
                return this.jobType.children.sort(
                    (jobTypeA, jobTypeB) => jobTypeA.order > jobTypeB.order ? 1 : -1
                );
            }
        },
        watch: {
            'jobType.selected'(newSelected) {
                if (newSelected === true) {
                    this.expanded = true;
                }
            }
        },
        components: {
            CurrencyInput
        }
    }
</script>

<style scoped lang="scss">
    .job-type-node {
        position:relative;
        &.root {
            margin-bottom: 5px;
        }
        margin-bottom: 0px;
        margin-top: 5px;
    }
    .caret-container {
        display: inline-block;
        cursor: pointer;
        padding: 0 8px;
        margin-right: 5px;
        font-size: 18px;
        width: 25px;
        border-radius: 4px;
        text-align: center;
        color: #6d6d6d;
        background: #eae5e5;
        line-height: 25px;
    &:hover {
        background: #e2e6d4;
    }
}
.job-type-name {
    margin-left: 2px;
    font-size: 14px;
}
.label-btn-style{
    /*background: #e6e6e6;*/
        /*border:1px solid #d8d8d8;*/
        /*color:black;*/
        border-radius: 4px;
        padding:8px 10px;
        word-break: break-word;
        overflow-wrap: break-word;
        margin-bottom: 0;
        font-weight: normal;
    }

    .label-btn-style span{
        margin-left:10px;
        line-height: 12px;
    }

    .partner-price-price{
        width: 55px;
        padding:4px;
        border-bottom-left-radius: 4px;
        border-top-left-radius: 4px;
        border:1px solid #d6d6d6;
        height: 30px;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        margin-top:4px;
    }
    .reset-partner-price-btn{
        background: #d1d1d1;
        color: gray;
        height: 30px;
        font-size: 17px;
        width: 42px;
        padding:0px;
        //line-height: 0px;
        border:1px solid #bebebe;
        border-left:0;
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;
    }
    .display-inline{
        display: inline-block;
        right: 4px;
        position: absolute;
    }

    .children {
        margin-left: 16px;
    }
    input[type=checkbox]
    {
        /* Double-sized Checkboxes */
        -ms-transform: scale(1.8); /* IE */
        -moz-transform: scale(1.8); /* FF */
        -webkit-transform: scale(1.8); /* Safari and Chrome */
        -o-transform: scale(1.8); /* Opera */
        //padding: 10px;
        margin : 0px;
    }

    .specific-skill{
        display:inline;
        padding: 10px;
        background: #dfdfdf;
        border-radius: 4px;
        margin-left: 10px;
    }
    .specific-skill label{
        margin-left: 4px;
        padding:8px;
    }
    .btn-control-partner-price-left{
      background: red;
    }
</style>
